import { deleteInsuranceTemplate } from "api/Documents";
import { queryClient } from "lib/helpers/configs/queryClient";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useDeleteTemplate = () => {

    const { t } = useTranslation()

    return useMutation(deleteInsuranceTemplate, {
        onSuccess: () => {
            queryClient.invalidateQueries("templates");

            toast.success(t("Deleted successfully"));
        },
        onError: () => {
            toast.error(t("Failed to delete"));
        },
    });
};
